import React from 'react';
import { useIntl } from 'react-intl';
import useDataQueries from '../../../../hooks/useDataQueries';
import BasicSettingsCard from './cards/BasicSettingsCard';
import VolumeManagementCard from './cards/VolumeManagementCard';
import ClassificationSettingsCard from './cards/ClassificationSettingsCard';
import AuthoritySettingsCard from './cards/AuthoritySettingsCard';

function RenderFormFields() {
  const { data, pending } = useDataQueries();
  const {
    modesOfIssuance = [],
    classificationTypes = [],
    loantypes = [],
    authoritySourceFiles = [],
  } = data;
  const { formatMessage } = useIntl();

  // Prepare options for components
  const modeOfIssuanceOptions = modesOfIssuance.map((mode) => ({
    value: mode.id,
    label: mode.name,
  }));

  const classificationTypeOptions = classificationTypes.map((type) => ({
    value: type.id,
    label: type.name,
  }));

  const loanTypeOptions = loantypes.map((type) => ({
    value: type.id,
    label: formatMessage({
      id: `ui-inventory.loantypes.name.${type.name}`,
      defaultMessage: type.name,
    }),
  }));

  const authoritySourceOptions = authoritySourceFiles
    .filter((source) => source.selectable === true)
    .map((source) => ({
      value: source.codes[0],
      label: source.name,
    }));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <BasicSettingsCard loanTypeOptions={loanTypeOptions} pending={pending} />

      <VolumeManagementCard
        modeOfIssuanceOptions={modeOfIssuanceOptions}
        pending={pending}
      />

      <ClassificationSettingsCard
        classificationTypeOptions={classificationTypeOptions}
        pending={pending}
      />

      <AuthoritySettingsCard
        authoritySourceOptions={authoritySourceOptions}
        pending={pending}
      />
    </div>
  );
}

export default RenderFormFields;
